import { useEffect, useState } from "react";

type UseInfiniteScrollOptions = {
  hasNextPage: boolean;
  isFetching: boolean;
  disabled?: boolean;
  fetchNextPage: () => void;
};

export const useInfiniteScroll = ({
  hasNextPage,
  isFetching,
  disabled = false,
  fetchNextPage,
}: UseInfiniteScrollOptions) => {
  const [sentinel, setSentinel] = useState<HTMLElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!sentinel) {
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { rootMargin: "200px" },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [sentinel]);

  const isSentinelVisible = sentinel !== null && isVisible;

  useEffect(() => {
    if (isSentinelVisible && hasNextPage && !isFetching && !disabled) {
      fetchNextPage();
    }
  }, [isSentinelVisible, hasNextPage, isFetching, disabled, fetchNextPage]);

  return setSentinel;
};
